import React from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import { Link as RouterLink } from 'react-router-dom';
// import IconChevronLeftLight from '../../resources/icons/IconChevronLeftLight.svg';
// import IconChevronRightLight from '../../resources/icons/IconChevronRightLight.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { IconChevronLeft, IconChevronRight } from '../atoms/Icons';
var SeeMoreButton = /*#__PURE__*/React.memo(function (_ref) {
  var pageEditing = _ref.pageEditing,
    listingPage = _ref.listingPage,
    seeMoreLabel = _ref.seeMoreLabel,
    rtl = _ref.rtl,
    analitycs = _ref.analitycs,
    params = _ref.params;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "news__link-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn-tertiary btn-tertiary--light"
  }, pageEditing ? /*#__PURE__*/React.createElement(Link, {
    className: "btn-tertiary btn-tertiary--light",
    field: listingPage.targetItem
  }) : /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary__text",
    to: listingPage.targetItem.url,
    onClick: function onClick() {
      tealiumClickFunc(tealiumMergeClickData(analitycs, params), 'See more');
    }
  }, seeMoreLabel.value, rtl ? /*#__PURE__*/React.createElement(IconChevronLeft, {
    className: "btn-tertiary__icon news__more-icon"
  }) : /*#__PURE__*/React.createElement(IconChevronRight, {
    className: "quick-links__icon"
  }))))));
});
export default SeeMoreButton;